// extracted by mini-css-extract-plugin
export default {"padded_icon":"InfoCard_padded_icon__0Bc3E","shadowed_box":"InfoCard_shadowed_box__1ilBu"};